import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Payload types for drawer actions
interface ImageDrawerPayload {
  prompt: string;
  onImageSelect: (url: string) => void;
}

interface TextDrawerPayload {
  prompt: string;
  currentContent: string;
  onTextSelect: (text: string) => void;
}

// Redux state - minimal, only drawer lifecycle + context + callbacks
interface DrawerState {
  imageDrawer: ImageDrawerPayload | null;
  textDrawer: TextDrawerPayload | null;
}

const initialState: DrawerState = {
  imageDrawer: null,
  textDrawer: null,
};

// Create the slice
const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    // Open image drawer - closes text drawer automatically
    openImageDrawer: (_, action: PayloadAction<ImageDrawerPayload>) => ({
      imageDrawer: action.payload,
      textDrawer: null,
    }),
    
    // Open text drawer - closes image drawer automatically
    openTextDrawer: (_, action: PayloadAction<TextDrawerPayload>) => ({
      imageDrawer: null,
      textDrawer: action.payload,
    }),
    
    // Close individual drawers
    closeImageDrawer: (state) => {
      state.imageDrawer = null;
    },
    
    closeTextDrawer: (state) => {
      state.textDrawer = null;
    },
  },
});

// Export actions
export const {
  openImageDrawer,
  openTextDrawer,
  closeImageDrawer,
  closeTextDrawer,
} = drawerSlice.actions;

// Export reducer
export default drawerSlice.reducer;

// Export types
export type { ImageDrawerPayload, TextDrawerPayload, DrawerState };
